/**
 * What the keys do.
 *
 * There are enough of them now that somebody coming back after a week will have
 * forgotten half, and hunting through tooltips is a poor way to be reminded.
 * Grouped the way the toolbar is, because that is the order they are learnt in.
 */

import { MODES, TRANSFORM_TOOLS } from './model';
import { Explain } from '../Explain';

export function EditorKeys(): JSX.Element {
  return (
    <div className="editor-body">
      <h3>Modes</h3>
      {MODES.map((entry) => (
        <div className="editor-fact" key={entry.mode}>
          <span>{entry.label}</span>
          <span>{entry.key}</span>
        </div>
      ))}

      <h3>Tools</h3>
      {TRANSFORM_TOOLS.map((entry) => (
        <div className="editor-fact" key={entry.tool}>
          <span>{entry.label}</span>
          <span>{entry.key}</span>
        </div>
      ))}

      <h3>Working</h3>
      <div className="editor-fact">
        <span>Add to the selection</span>
        <span>Ctrl click</span>
      </div>
      <div className="editor-fact">
        <span>Nudge what is held</span>
        <span>Arrows</span>
      </div>
      <div className="editor-fact">
        <span>Copy, cut, paste</span>
        <span>Ctrl C X V</span>
      </div>
      <div className="editor-fact">
        <span>Take back, put again</span>
        <span>Ctrl Z Y</span>
      </div>
      <div className="editor-fact">
        <span>Remove</span>
        <span>Delete</span>
      </div>
      <div className="editor-fact">
        <span>Put everything down</span>
        <span>Escape</span>
      </div>

      <h3>Looking</h3>
      <div className="editor-fact">
        <span>Move the view</span>
        <span>W A S D</span>
      </div>
      <div className="editor-fact">
        <span>Look at what is held</span>
        <span>F</span>
      </div>
      <div className="editor-fact">
        <span>Back to your character</span>
        <span>G</span>
      </div>
      <div className="editor-fact">
        <span>Write the world out</span>
        <span>Ctrl S</span>
      </div>

      <h3>
        Building upwards
        <Explain>
          Pick Up 1 in the bar, lay boards where the upper floor should be, and put walls on the
          same storey around them. Everything up there is solid until boards are laid: the floor is
          what makes the room. For a way up, put Stairs (up) on the ground and Stairs (down) on the
          storey above, on the tile you want to come back down from.
        </Explain>
      </h3>
      <div className="editor-fact">
        <span>Lay the floor first</span>
        <span>Up 1</span>
      </div>
      <div className="editor-fact">
        <span>Stairs, both halves</span>
        <span>Up and down</span>
      </div>
    </div>
  );
}
